import React from 'react';
import './styles/Input.css';
import './styles/Button.css';
import './styles/Layout.css';
import {
  HashRouter as Router,
  Switch,
  Route, 
  Link
} from "react-router-dom";
import OrderPage from './pages/OrderPage';
import ConfirmationPage from './pages/ConfirmationPage';
import HomePage from './pages/HomePage';
import logo from './images/curby-icon.png';

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="navbar">
        <img src={logo} className="navbar-logo" alt="curby logo"/>
        <h1> curby </h1>
        {/*<Link to="/"> Home </Link>
        <Link to="/confirmation"> Confirmation </Link>
        <Link to="/order"> Order </Link>*/}
      </div>
      <Switch>
        <Route 
          path="/confirmation/:id"
          render={props => <ConfirmationPage match={props.match}/>}>
        </Route>
        <Route path="/order" >
          <OrderPage/>
        </Route>
        <Route path="/" >
          <OrderPage/>
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
